import { BehaviorSubject } from 'rxjs';
import { Asset } from './Asset';
import { RpmAccount } from './RpmAccount';
import { User } from './User';
import { ComponentName, Link } from '../components/Compounds/DetailsDrawer/detailsDrawersHelpers';
import { SupplierMap } from './SupplierMap';
import { ApMap } from './ApMap';
import { ProvisionalAsset } from './ProvisionalAsset';
import { Link as TallyLink } from './Link';
import { ProductMap } from './ProductMap';
import { CustomerMap } from './CustomerMap';
import { RunTotalAudit } from './RunTotalAudit';
import { Payment } from './Payment';
import { PaymentRecipient } from './PaymentRecipient';
import { Correction } from './Correction';
import { Ticket } from './Ticket';
import { Adjustment } from './Adjustment';

export type DrawerData =
  | Asset
  | User
  | RpmAccount
  | SupplierMap
  | ProvisionalAsset
  | TallyLink
  | RunTotalAudit
  | ApMap
  | ProductMap
  | CustomerMap
  | Payment
  | PaymentRecipient
  | Correction
  | Ticket
  | Adjustment;

export enum DrawerDataType {
  ASSET = 'asset',
  PROVISIONAL_ASSET = 'provisionalAsset',
  USER = 'user',
  RPM_ACCOUNT = 'rpmAccount',
  RUN_TOTAL_AUDIT = 'runTotalAudit',
  SUPPLIER_MAP = 'supplierMap',
  AP_MAP = 'apMap',
  CORRECTION = 'correction'
}

export interface DrawerState {
  id: string;
  data: DrawerData;
  title: string;
  subtitleKey?: string;
  componentName: ComponentName;
  idKey?: string;
  link?: string;
  linkGroup?: Link[];
  dataSubject?: () => BehaviorSubject<DrawerData | undefined>;
  updateSubject?: (data: DrawerData) => void;
  showButtons?: boolean;
  showIcon?: boolean;
  titleKey?: string;
  saveAction?: (data: DrawerData) => void;
  deleteAction?: () => void;
  replace?: boolean;
  showExpand?: boolean;
  showArchived?: boolean;
  fullPageLink?: string;
  fetchFunction?: () => Promise<DrawerData | undefined>;
  type?: string;
}

const drawersSubject = new BehaviorSubject<DrawerState[]>([]);
const drawerOpenSubject = new BehaviorSubject<boolean>(false);
const fromDrawerSubject = new BehaviorSubject<boolean>(false);

export const getDrawersSubject = (): BehaviorSubject<DrawerState[]> => drawersSubject;
export const getDrawerOpenSubject = (): BehaviorSubject<boolean> => drawerOpenSubject;
export const getFromDrawerSubject = (): BehaviorSubject<boolean> => fromDrawerSubject;

export const updateDrawerOpenSubject = (newStatus: boolean) => drawerOpenSubject.next(newStatus);
export const updateFromDrawerSubject = (newStatus: boolean) => fromDrawerSubject.next(newStatus);
export const clearDrawerState = () => drawersSubject.next([]);

/** Removing this for now, will revisit later */
// export const animateDrawer = () => {
//   const openState = getDrawerOpenSubject().getValue();
//   if (openState) {
//     drawerOpenSubject.next(false);
//     setTimeout(() => drawerOpenSubject.next(true), 250);
//   } else drawerOpenSubject.next(true);
// };

export const addDrawer = (data: DrawerState) => {
  if (data.replace) drawersSubject.next([data]);
  else drawersSubject.next([data, ...drawersSubject.getValue()]);
  // animateDrawer();
  updateDrawerOpenSubject(true);
};

export const removeDrawer = (id: string) => {
  const currentDrawers = [...drawersSubject.getValue()];
  const updatedDrawers = currentDrawers.filter((item) => item.id !== id);
  drawersSubject.next(updatedDrawers);
  // animateDrawer();
  if (updatedDrawers.length === 0) updateDrawerOpenSubject(false);
};
